export const IS_CUSTOM_PAGE = 'IS_CUSTOM_PAGE';
export const isCustomPage = ({ isCustom, name }) => {
    return {
        type: IS_CUSTOM_PAGE,
        customPage: {
            isCustom,
            name
        }
    }
};
